import { apiFetch } from '@/shared/lib/apiClient';
import type { ActivateCodeDto, CodeStatusResponseDto } from '@/shared/lib/apiTypes';

/**
 * 코드 1건을 서버에 등록(활성화) 요청한다.
 *
 * Swagger: `POST /api/code/activate/{userCode}` — 사전 등록된 CodeList 의 코드를 입력하여
 * 본인 userCode 앞으로 등록한다. 응답에는 갱신된 누적 카운트와 (임계값 도달 시) 다운로드 URL 이 포함된다.
 *
 * @param userCode - 본인 유저 코드 (6자리 영숫자).
 * @param code     - 사용자가 입력한 등록 대상 코드 (4자리 영숫자, 이미 정규화된 상태).
 * @returns 갱신된 누적 카운트와 다운로드 URL.
 * @throws ApiError(400) 잘못된 코드 또는 이미 등록된 코드.
 * @throws ApiError(404) userCode 에 해당하는 유저를 찾을 수 없음.
 * @throws ApiError(429) 등록 시도 제한(1분당 10회) 초과.
 */
export async function activateCode(
  userCode: string,
  code: string,
): Promise<CodeStatusResponseDto> {
  const body: ActivateCodeDto = { code };
  return apiFetch<CodeStatusResponseDto>(
    `/api/code/activate/${encodeURIComponent(userCode)}`,
    { method: 'POST', body },
  );
}
